<template>
  <aside :class="{ active: isActive, 'active-mobile': isActive }">
    <ul>
      <li @click="asideClose">
        <!-- < <a href="#" @click="modalShow"> #打開coming soon pop-up -->
        <a :href="'//starluxairlines.sharepoint.com/sites/cfdcloud'" target="_blank">
          <div class="icon">
            <img src="img/icon_shield.svg" />
          </div>
          <div class="text">SMS</div>
        </a>
      </li>
      <li @click="asideClose">
        <!-- <a :href="'//starluxairlines.asqs.net/'" target="_blank"> -->
        <a :href="'https://starluxairlines.asqs.net/'" target="_blank">
          <div class="icon">
            <img src="img/icon_safetymanager.png" />
          </div>
          <div class="text">SafetyManager<br />365</div>
        </a>
      </li>
      <li @click="asideClose">
        <a :href="'//starluxairlines.sharepoint.com/sites/EIP'" target="_blank">
          <div class="icon">
            <i class="icons icon-plane"></i>
          </div>
          <div class="text">STARLUX EIP</div>
        </a>
      </li>
      <li @click="asideClose">
        <a :href="'https://jxcrew.starlux-airlines.com/jxcrew/quals'" target="_blank">
          <div class="icon">
            <i class="fa fa-vcard-o"></i>
          </div>
          <div class="text">My Qualification</div>
        </a>
      </li>
      <li @click="asideClose">
        <a :href="'/#/d1folderlist/personnel info'">
          <div class="icon">
            <i class="fa fa-user-circle"></i>
          </div>
          <div class="text">Personnel Info</div>
        </a>
      </li>
      <li @click="asideClose">
        <a :href="'/#/StaticFolderList/manual'">
          <div class="icon">
            <img src="img/icon_library.svg" />
          </div>
          <div class="text">Manual</div>
        </a>
      </li>
      <li @click="asideClose">
        <a :href="'//etdn.starlux-airlines.com/'" target="_blank">
          <div class="icon">
            <i class="icons icon-book-open"></i>
          </div>
          <div class="text">eTDS</div>
        </a>
      </li>
      <li @click="asideClose">
        <a href='https://starlux-ftrs.peakpacificgroup.com/' target="_blank">
          <div class="icon">
            <img src="img/icon_ALTO.png" />
          </div>
          <div class="text">ALTO</div>
        </a>
      </li>
      <li @click="asideClose">
        <a :href="'/#/StaticFolderList/training material'">
          <div class="icon">
            <i class="fa fa-book"></i>
          </div>
          <div class="text">Training Material</div>
        </a>
      </li>
      <li @click="asideClose">
        <a :href="'/#/d1folderlist/supervisory pilots'">
          <div class="icon">
            <img src="img/icon_supervisory.svg" alt="" />
          </div>
          <div class="text">Supervisory Pilots</div>
        </a>
      </li>
      <li @click="asideClose">
        <router-link :to="{ name: 'TransPort' }">
          <div class="icon">
            <img src="img/icon_transport.svg" />
          </div>
          <div class="text">Transport</div>
        </router-link>
      </li>
      <li @click="asideClose">
        <a href="selfserviceios://">
          <div class="icon"><img src="img/icon_hub.svg" /></div>
          <div class="text">Pilot Apps</div>
        </a>
      </li>
      <li @click="asideClose">
        <a :href="'/#/folderdetail/pss'">
          <div class="icon">
            <span class="fa-stack">
              <i class="fa fa-file-o fa-stack-1x"></i>
              <i class="fa fa-plane text-sm fa-stack-1x mt-5"></i>
            </span>
          </div>
          <div class="text">Schedule Info</div>
        </a>
      </li>
      <li @click="asideClose">
        <a :href="'/#/d1folderlist/hotel'">
          <div class="icon">
            <img src="img/icon_building.svg" />
          </div>
          <div class="text">Stay Hotel Info</div>
        </a>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  props: ['active'],
  data: () => ({
    modalIsShow: true
  }),
  methods: {
    modalShow() {
      this.$emit('asideModal', true)
    },
    asideClose() {
      this.$emit('asideClose', this.active)
    },
    outsideAside() {
      document.addEventListener('click', e => {
        if (this.active === true) {
          if (!e.target.closest('aside') && !e.target.closest('.icon-menu')) {
            this.$emit('asideClose', this.active)
          }
        }
      })
    }
  },
  computed: {
    isActive() {
      return this.active
    },
    asideClick() {
      return this.$route.params.name
    }
  },
  mounted() {
    this.outsideAside()
  }
}
</script>
